import * as React from 'react';
import { IStylingFirm } from '../Entities';
import StylingFirmsListRow from './StylingFirmsListRow';
import { Translate } from '../../../shared/LanguageService';

interface IStylingFirmsListProps {
    stylingFirms: IStylingFirm[];
    editStylingFirm: (id: number) => void;
    viewlogs: (id: number) => void;
    deleteStylingFirm: (id: number) => void;
}

const StylingFirmsList = (props: IStylingFirmsListProps) => {
    return (
        <table className="table table-hover table-responsive">
            <thead>
                <tr>
                    <th>{Translate('styling-firms/list/header/name')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.stylingFirms &&
                    props.stylingFirms
                        .sort((a: IStylingFirm, b: IStylingFirm) => {
                            if (a.name < b.name) {
                                return -1;
                            }
                            if (a.name > b.name) {
                                return 1;
                            }

                            return 0;
                        })
                        .map((stylingFirm: IStylingFirm, index: number) => {
                            return (
                                stylingFirm && (
                                    <StylingFirmsListRow
                                        key={index}
                                        stylingFirm={stylingFirm}
                                        editStylingFirm={props.editStylingFirm}
                                        viewlogs={props.viewlogs}
                                        deleteStylingFirm={props.deleteStylingFirm}
                                    />
                                )
                            );
                        })}
            </tbody>
        </table>
    );
};

export default StylingFirmsList;
